export default "Éco-PTZ Collectif Copropriété 2026 — Prêt à Taux Zéro pour travaux collectifs | Solution Éco France";
